var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('button',{staticClass:"center call",on:{"click":_vm.start}},[_vm._v(" Start now "),_c('v-icon',{staticStyle:{"margin-left":"8px"},attrs:{"name":"chevron-right"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }